<template>
  <div style="position: sticky; top: 0;z-index: 999;">
    <div class="top">
      <div class="top_logo" @click="$router.push('/')">
        <img src="@/imgs/logo.svg" class="top_logo_pic" />
      </div>

      <div class="teo">
        <el-menu class="elMenuL" style="flex: 3; height: 100%; display: inline-flex; border: none"
          active-text-color="#dc383b" :default-active="$router.currentRoute.name">
          <el-menu-item index="gallery" id="big" @click="pushGallery">图片</el-menu-item>
          <el-menu-item index="videosource" id="big" @click="pushVideosource">视频</el-menu-item>
          <el-menu-item index="destination" id="big" @click="pushDestination">影像馆</el-menu-item>
          <el-menu-item index="photographer" id="big" @click="pushPhotographer">摄影师</el-menu-item>
          <el-menu-item index="activities" id="big" @click="pushActivities">大赛/征稿</el-menu-item>
          <el-menu-item index="VR" id="big" @click="$router.push('/VR')">VR视频</el-menu-item>

        </el-menu>

        <el-menu class="top_btn"
          style="flex: 2; height: 100%;display: inline-flex; flex-direction: row-reverse;  border: none;">
          <el-menu-item id="big" class="login_btn" v-if="!headerShow" @click="$router.push('/login')">登录</el-menu-item>
          <el-menu-item id="big" class="login_btn lgggg" v-if="headerShow">
            <!-- :src="require('../imgs/wx.png')"  -->
            <el-dropdown trigger="click" @command="handleCommand">
              <div style="position: relative;">
                <img v-if="usermember == 1 && userInfo.userType == 2" class="hVIP" src="@/imgs/header-vip.svg" alt="" />
                <img v-else-if="userInfo.userType == 1" class="hVIP" src="@/imgs/header-sys.svg" alt="" />
                <img v-else-if="userInfo.userType == 0" class="hVIP" src="@/imgs/header-yxg.svg" alt="" />
                <img class="headerimage" style="" :src="userInfo.headImage" />

              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :title="userInfo.username">{{ userInfo.username }}</el-dropdown-item>
                <el-dropdown-item @click.native="pushUserIndex">用户中心</el-dropdown-item>
                <el-dropdown-item @click.native="pushMyWork">我的主页</el-dropdown-item>
                <el-dropdown-item @click.native="pushMyPhoto">免费图片上传</el-dropdown-item>
                <el-dropdown-item @click.native="pushMyVideo">免费视频上传</el-dropdown-item>
                <!-- <el-dropdown-item>作品管理</el-dropdown-item> -->
                <!-- <el-dropdown-item>我的收藏</el-dropdown-item> -->
                <!-- <el-dropdown-item>帐号设置</el-dropdown-item> -->
                <!-- <el-dropdown-item>身份认证</el-dropdown-item> -->
                <el-dropdown-item command='h'>退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </el-menu-item>
          <!-- <el-menu-item id="big" class="login_btns" style="cursor: pointer; margin: 0 20px">
              <img style="position: static" src="../imgs/shangchuan2.png" />上传
            </el-menu-item> -->
          <el-menu-item id="big" class="login_btns" @click="pushContributor">
            <img id="ggrImg" src="../imgs/provide.svg" />
            供稿人
          </el-menu-item>
          <el-menu-item id="big" class="login_btns" @click="pushVip">
            <img id="ggrImg" src="../imgs/top-vip.svg" />
            购买会员</el-menu-item>
          <el-menu-item>
            <div class="searchMini " @click="$router.push('/photoSearchResule?type=img')">
              <img src="@/imgs/top-search.svg" alt="">
            </div>
          </el-menu-item>
          <!-- <el-menu-item
              id="big"
              class="login_btns"
              style="margin: 0 20px"
              @click="$router.push('/search')"
            >
              <img
                style="position: static"
                src="../imgs/akar-icons_search.png"
              />
              搜索
            </el-menu-item> -->
        </el-menu>
      </div>

    </div>
  </div>
</template>

<script>
import img_url from "../assets/logo.png";
import { setLocalStorage } from "../utils/auth";
import { getLocalStorage } from "../utils/auth";
import { setToken } from "../utils/auth";
import { loginout } from "../directives/loginout.js";

export default {
  name: "top",
  props: ['headShow', 'uInfo'],
  data() {
    return {
      userInfo: {},
      scroll: 0,
      usermember: null,//是否为会员
      token: '',
      activeIndex: "/",
      userData: {},
      isActived: true,
      keyword: "",
      preSearch: "work",
      headerShow: false,
      unlisted: false,
      form: {
        account: "",
        password: "",
      },
      activeName: "登录",
      // panel_open: false,
    };
  },
  watch: {
    // userInfo: {
    //   handler(newVal, old) {
    //     console.log(newVal);
    //   },
    //   immediate: true,
    //   deep: true,
    // }
  },
  created() {
    this.token = window.localStorage.getItem('token')
    if (this.token) {
      this.getUserMember() //获取用户是否为会员
    }

    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      this.headerShow = true
      this.userInfo = JSON.parse(userInfo);
      console.log(this.userInfo.userType);
    } else {
      this.headerShow = false
    }

    if (getLocalStorage("user_id") == null) {
      this.unlisted = true;
    } else {
      this.$axios
        .post("/user/userinfo", {
          id: getLocalStorage("user_id"),
        })
        .then((res) => {
          console.log(res);
          this.userData = res.result;
          this.unlisted = false;
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //  if(LocalStorage.userInfo){
    //        this.uInfo=LocalStorage.userInfo
    // }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('setItemEvent', (e) => {
        if (e.key == 'userInfo') {
          // console.log(e);
          // return console.log(JSON.parse(e.newValue));
          this.userInfo = JSON.parse(e.newValue);
        }
      })
      window.addEventListener('scroll', this.handleScroll)
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      //或者使用document.querySelector('.class或者#id').scrollTop
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      // console.log(this.scroll)
      // 300
    },
    // 查询用户是否为会员
    async getUserMember() {
      if (window.localStorage.getItem('token') && window.localStorage.getItem('userInfo')) {
        let res = await this.$axios.get("/member/getMember");
        this.usermember = res.data.memberStatus
      }

    },
    // 跳转到图片
    pushGallery() {
      this.$router.push('/gallery')
    },
    // 跳转到视频

    pushVideosource() {
      this.$router.push('/videosource')
    },

    // 跳转到影像馆
    pushDestination() {
      this.$router.push('/destination')
    },

    // 跳转到摄影师
    pushPhotographer() {
      this.$router.push('/photographer')
    },
    // 跳转到活动征稿
    pushActivities() {
      this.$router.push('/activities')
    },

    // 点击跳转供稿人平台
    pushContributor() {
      // if (!this.token) {
      //   this.$message.error('请先登录！')
      //   this.$router.push('/login')
      //   return
      // }
      const { href } = this.$router.resolve({
        path: '/contributor',

      })
      window.open(href, '_blank')
    },

    // 跳转到vip
    pushVip() {
      console.log(12);
      const { href } = this.$router.resolve('/vip')
      window.open(href, '_blank')

    },

    out() {
      window.localStorage.clear();
      this.unlisted = true;
    },
    onSubmit() {
      var req_url;
      if ((this.activeName = "登录")) req_url = "/user/login";
      else req_url = "/user/register";
      this.$axios
        .post(req_url, {
          account: this.form.account,
          password: this.form.password,
        })
        .then((res) => {
          console.log(res);
          if (res.code < 0) {
            this.$message.error(res.msg);
          } else {
            this.$message({
              message: this.activeName + "成功",
              type: "success",
            });
            this.resetForm();
            this.panel_open = false;
            setLocalStorage("token", res.result.token.token);
            setToken(res.result.token.token);
            this.$axios
              .post("/user/userinfo", {
                id: res.result.user.id,
              })
              .then((res2) => {
                setLocalStorage("account", res2.result.account);
                setLocalStorage("user_id", res2.result.id);
                setLocalStorage("user_name", res2.result.user_name);
                setLocalStorage("intro", res2.result.intro);
                setLocalStorage("user_url", res2.result.user_url);
                this.userData = res2.result;
              });
            this.unlisted = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetForm() {
      // 重置
      (this.form.account = ""), (this.form.password = "");
    },
    search() {
      var route = this.$router.resolve({
        path: "/search",
        query: {
          type: this.preSearch,
          name: this.keyword,
        },
      });
      window.open(route.href, "_blank");
    },
    panel_open() {
      window.open(route.href, "../login");
    },
    // 进入用户中心
    pushUserIndex() {
      this.$router.push({
        path: '/userIndex',
      })

    },

    // 进入我的作品
    pushMyWork() {

      // return console.log(this.userInfo);
      if (this.userInfo.userType == 0) {
        this.$router.push({
          path: `destinationHome?id=${this.userInfo.userId}`,
        })
      } else {
        this.$router.push({
          path: '/myWork',
        })
      }

      // if (JSON.parse(window.localStorage.getItem('userInfo')).userType == 0) {
      //   this.$router.push({
      //     path: '/destinationHome',
      //   })

      // } else {
      //   this.$router.push({
      //     path: '/myWork',
      //   })

      // }

    },

    //跳转到我的图片
    pushMyPhoto() {
      this.$router.push({
        path: '/userIndex?leftTab=4',
      })
    },
    //跳转到我的视频
    pushMyVideo() {
      this.$router.push({
        path: '/userIndex?leftTab=5',
      })
    },

    // 退出登录
    handleCommand(command) {
      if (command == 'h') {
        this.headerShow = false
        window.localStorage.clear()
        this.$router.push('/login')
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.top {
  padding-left: 20px;
  padding-right: 15px;
  width: 100%;
  height: 51px;
  text-align: center;
  font-size: 18px;
  font-family: "Microsoft YaHei";
  display: flex;
  border: none !important;
  background-color: #fff;
  // border-bottom: 1px solid #e6e6e6;
  position: sticky;
  top: 0;
  z-index: 9999999999;

  .top_logo {
    // float: left;
    margin: 0px 0px;
    height: 100%;
    width: 145px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .teo {
    transform: translateY(-3px);
    width: 100%;
    font-family: "Microsoft YaHei";
    flex-direction: row;
    background-color: #fff;
    display: flex;

    /deep/ .el-menu-item {
      height: 100%;
      line-height: 53px;

    }
  }
}

.com {
  width: 60%;
  margin-top: 20px;
  align-items: center;
  color: #353535;
  padding-left: 30px;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  background-color: #fbfafa;
  flex-direction: row;
}

.coms {
  margin: 0 auto;
  // z-index: 9999999;
  position: relative;
  width: 800px;
  align-items: center;
  background-color: #fbfafa;
  color: #353535;
}

// .menuItem {
//   /deep/ .el-dropdown-item {
//     &:hover {
//       background-color: #db3a3b !important;
//     }
//   }
// }

.el-menu-item.is-active {
  font-weight: bold;
}



.grid-content {
  min-width: 50px;
}

.login_btns .img {
  width: 21px;
  height: 11px;
}



.login_btn>>>.el-dropdown-menu__item {
  width: 100%;
  height: 51px;
  display: inline-block;
}

.login_btn>>>.el-dropdown-menu__item {
  background-color: red;
  color: #fff;
}

#big {
  transition: 0.3s;

  &:hover {
    color: #db3a3b !important;
    font-weight: 700;
    background-color: #fff !important;
  }
}

.lgggg {
  // width: 62px;
  height: 62px;
}

.headerimage {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top_logo_pic {}


.el-dropdown-menu__item:not(.is-disabled) {
  &:hover {
    color: #fff;
  }
}

#ggrImg {
  width: 30px;
  height: 30px;
}


/deep/ .el-dropdown-menu__item {
  max-width: 180px;
  overflow: hidden; //超出部分隐藏
  text-overflow: ellipsis; //超出部分显示...
  white-space: nowrap; //文本强制一行显示    
}

.hVIP {
  position: absolute;
  bottom: -1px;
  right: -9px;
  width: 20px;
  height: 20px;
  z-index: 98999999;
}


.elMenuL {
  margin-left: 15px;
}

.searchMini {
  img {
    width: 20px;
    height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue